import template from 'header/search.j2';
import { mDom, mDomMaintainInputVals } from '../../../core/js/utils/renderUtils';
import Config from '../configs/config.js';
import {
    CLOSE_SITE_SEARCH,
    OPEN_SITE_SEARCH,
    editSiteSearch,
    enhancedSaytSearch,
    enhancedSaytSearchResults
} from '../actions/headerActions.js';

import { handleUtagEvent } from '../../../core/js/actions/initialActions.js';

import { sanitizeInput } from '../utils/validationUtils';
import { isTabPressed } from '../utils/keyUtils';

import { generate } from '../../../core/js/utils/componentUtils';
import { getDefaultOptions } from '../../../core/js/utils/a15componentUtils';
import { createGAEvent } from '../utils/analyticsUtils';
import { getSaytEventLabel } from '../utils/saytUtils';
import { handleSearchSubmitAnalytics } from '@core/js/utils/searchUtils';
import { isSiteMenuOpen } from '@core/js/utils/headerUtils';

const domSelector = '.dom-site-search';
const searchInputSelector = '.js-site-search__input';

function firstRender(store) {
    this.render(store, this, {});
}

function getSearchValue() {
    const userInputtedValue = $(this.scopedSelector(searchInputSelector)).val();

    if (userInputtedValue && _.isString(userInputtedValue)) {
        return userInputtedValue.trim();
    }

    return '';
}

function isSiteSearchOpen() {
    return !_.isEmpty($('.has-site-search-open'));
}

function setSearchValue(value) {
    $(this.scopedSelector(searchInputSelector)).val(value);
}

function generateComponentDictionary(state, dictionary, config) {
    // Decide which trending keywords should be displayed based on input.
    let trendingData;
    let popularData = [];
    let productResultsSearchTerm = '';
    const displayProductResultsRight = _.get(state, 'core.constants.enhancedSayt.display_product_results_right', false);

    // if we have no input, or trending results are blank, show default trending
    const trending = _.get(state, 'core.sayt.header.trending', []);
    const defaultTrending = _.get(state, 'core.sayt.header.defaultTrending', []);
    const productResults = _.get(state, 'core.sayt.header.popularProducts', []);
    const defaultProducts = _.get(state, 'core.sayt.header.defaultPopularProducts', []);
    const searchSuggestions = _.get(state, 'core.sayt.header.searchSuggestions', []);
    const searchFieldIsEmpty = _.isEmpty(this.getSearchValue());
    const hasTrendingResults = !_.isEmpty(trending);

    if (!searchFieldIsEmpty && hasTrendingResults) {
        trendingData = trending;
    } else {
        trendingData = defaultTrending;
    }

    // only FP mobile shows popular products
    const screenIsSmallOrMedium = _.get(state, 'core.deviceCharacteristics.is_smallish', false) ||
                                  _.get(state, 'core.deviceCharacteristics.is_medium', false);
    const hasProductResults = !_.isEmpty(productResults);

    if (!searchFieldIsEmpty && hasProductResults) {
        if (!screenIsSmallOrMedium) {
            popularData = productResults;

            // If on desktop, and have a search term, and have product results, append suggestion used to header string
            if (searchSuggestions.length > 0) {
                productResultsSearchTerm = searchSuggestions[0];
            }
        }
    } else {
        popularData = defaultProducts;
    }

    // Construct GA data attributes to be used in the product tile for popularData
    const productSuggestionType = _.size(productResults) > 0 ? 'product' : 'popular';
    _.forEach(popularData, (product, index) => {
        product.gaAttributes = [
            `data-suggestion-index=p${index + 1}`,
            `data-suggestion-type=${productSuggestionType}`
        ];

        // [GA] Add product name to href as query param for SAYT product tiles
        let queryParams = _.get(product, 'product.queryParams', '');
        const displayName = _.get(product, 'product.displayName', '');
        const ampChar = (queryParams) ? '&' : '';

        if (displayName && queryParams.indexOf('q=') < 0) {
            queryParams = `${queryParams}${ampChar}q=${displayName}`;
            product.product.queryParams = queryParams;
        }

    });

    return Object.assign({}, state,
        dictionary, {
            trendingData: trendingData,
            popularData: popularData,
            productResultsSearchTerm: productResultsSearchTerm,
            displayProductResultsRight: displayProductResultsRight
        }
    );
}

/*
 * Send the utag event when a user picks a SAYT suggestion (for Google Analytics)
 * - saytSelection: trending term text or product tile slug
 * - suggestionType: 'popular' products, 'product' results, 'trending' terms, or 'autocomplete'
 * - index: # order of the selection. (e.g. p3 = 3rd product tile, t5 = fifth trending term)
 * - sayt_suggestion_index: index of suggestion picked
 * - sayt_suggestion_origin: 'sayt', 'trending', 'suggestedProduct' (See UW-11087)
 */
function handleSaytSearch(store, saytSelection, suggestionType, index) {
    const state = store.getState();
    let eventLabel = saytSelection;
    const saytPopularOverrideCategory = _.get(state, 'core.featureConfigs.headerFeatureConfig.saytPopularOverride', '');
    let eventCategory = 'sayt_search';
    let eventAction = suggestionType;
    let customDimensions = {
        'sayt_suggestion_origin': window.location.href,
        'sayt_suggestion_index': index
    };

    if (suggestionType === 'popular' || suggestionType === 'product') {
        eventCategory = _.get(state, 'core.pageType', 'none');
        if (saytPopularOverrideCategory.length > 0 && suggestionType === 'popular') {
            eventAction = `sayt|${saytPopularOverrideCategory}`;
        } else {
            eventAction = `sayt|${suggestionType}|${index}`;
            customDimensions = _.omit(customDimensions, 'sayt_suggestion_index');
        }
    } else if (suggestionType === 'trending' || suggestionType === 'autocomplete') {
        eventCategory = _.get(state, 'core.pageType', 'none');
        eventAction = `sayt|${suggestionType}`;
        eventLabel = eventLabel.trim();
    }

    const gaEvent = createGAEvent(eventCategory, eventAction, eventLabel, customDimensions);

    store.dispatch(handleUtagEvent(gaEvent, 'link'));
}

export function attachEvents(store) {
    const _this = this;
    const deviceCharacteristics = this.getDeviceCharacteristics();
    const isLargeDevice = deviceCharacteristics.is_large || deviceCharacteristics.is_extra_large;

    // 'keyup' check for empty input and clear sayt results
    $(document).on(this.scopedEvent('keyup'), this.scopedSelector(searchInputSelector), (e) => {
        const searchValue = _this.getSearchValue();
        const isClearable = searchValue.length > 0;
        const searchSource = e.target.dataset.searchSource;

        store.dispatch(editSiteSearch(isClearable, searchSource));

        if (searchValue.length === 0) {
            store.dispatch(enhancedSaytSearchResults({}, [], searchSource, e));
        }
    });

    // 'mouseup' check for empty input and clear sayt results
    // using a debounce here in place of a timeout on the value check
    // when clicking the x, it only clears on mouseup also so .val of
    // the input hasn't cleared yet.
    // $(document).on(this.scopedEvent('mouseup'), this.scopedSelector(searchInputSelector), _.debounce((e) => {
    //     if (_this.getSearchValue().length === 0) {
    //         store.dispatch(enhancedSaytSearchResults({}, [], e.target.dataset.searchSource, e));
    //     }
    // }, Config.search.debounce));
    // NOTE: removed the code above to allow default trending results to show on focus

    // 'keypress' handles all key strokes for visual character keys
    $(document).on(this.scopedEvent('keypress'), this.scopedSelector(searchInputSelector), _.debounce((e) => {
        const searchTerm = _this.getSearchValue();

        store.dispatch(enhancedSaytSearch(searchTerm, e.target.dataset.searchSource, e));
    }, Config.search.debounce));

    // 'keydown' will handle non character strokes like delete or backspace changing input value.
    $(document).on(this.scopedEvent('keydown'), this.scopedSelector(searchInputSelector), _.debounce((e) => {
        const BACKSPACE = 8;
        const DELETE = 46;

        if ((e.keyCode === BACKSPACE || e.keyCode === DELETE)) {
            const searchTerm = _this.getSearchValue();

            store.dispatch(enhancedSaytSearch(searchTerm, e.target.dataset.searchSource, e));
        }
    }, Config.search.debounce));

    // another 'keydown' that we don't want debounced for the escape/return key
    // 'keydown' action focuses first list item on down arrow
    $(document).on(this.scopedEvent('keydown'), this.scopedSelector(searchInputSelector), (e) => {
        const ESCAPE = 27;
        const RETURN = 13;
        const DOWN = 40;

        if (e.keyCode === RETURN && _this.getSearchValue() === '') {
            return false;
        }

        if (e.keyCode === ESCAPE) {
            _this.setSearchValue("");
            store.dispatch(enhancedSaytSearchResults({}, [], e.target.dataset.searchSource, e));
        }

        if (e.keyCode === DOWN) {
            $('.js-search-suggestion:first').focus();
            e.preventDefault();
        }

        return true;
    });

    // Another 'keydown' that is bound to the document.
    // This is specifically used to close the SAYT menu once you
    // have hit tab while being focused on the last SAYT suggestion
    // We have to bind to the document because once you hit tab for the first time,
    // you are no longer within the context of the scoped selector
    $(document).on(('keydown'), (e) => {
        if (!isTabPressed(e) || !isLargeDevice || $('.js-site-search-sayt a:last:focus').length < 1) { return; }
        const scopedSelector = $(this.scopedSelector(searchInputSelector));

        scopedSelector.val('');
        store.dispatch(enhancedSaytSearchResults({}, [], scopedSelector.attr('data-search-source'), e));
        $.event.trigger({
            type: CLOSE_SITE_SEARCH
        });
    });

    // 'focus' opens search, and binds document 'click' event to clear results and close search
    $(document).on(this.scopedEvent('focus'), this.scopedSelector(searchInputSelector), (e) => {
        const state = store.getState();
        const hasDefaultTrending = !_.isEmpty(_.get(state, 'core.sayt.header.defaultTrending'));
        const $searchField = $(e.target);
        const searchSource = e.target.dataset.searchSource;
        const searchTerm = $searchField.val().trim();
        const inputHasValue = searchTerm.length > 0;

        // Note: vdom doesn't seem to merge the autocomplete, autocapitalize, or spellcheck attributes correctly.
        $searchField.attr({
            'autocomplete': 'off',
            'autocapitalize': 'off',
            'spellcheck': 'false',
            'autocorrect': 'off'
        });

        if (inputHasValue) {
            store.dispatch(enhancedSaytSearch(searchTerm, searchSource, e));
        } else if (!hasDefaultTrending) {
            store.dispatch(enhancedSaytSearch(null, searchSource, e));
        }

        store.dispatch(editSiteSearch(inputHasValue, searchSource));

        const siteSearchDocumentListener = (event) => {
            if (!$(event.target).parents(this.templateLocation).length && !$(event.target).hasClass(this.className) && !isSiteMenuOpen()) {
                $(document).off('click', siteSearchDocumentListener);
                store.dispatch(enhancedSaytSearchResults({}, [], searchSource, event));
                if (this.templateLocation === domSelector) {
                    $.event.trigger({
                        type: CLOSE_SITE_SEARCH
                    });
                }
            }
        };

        $(document).on('click', siteSearchDocumentListener);

        // UW-6240 On mobile prevent users search term from being cleared upon re-tap of the text
        // input field once the user has collapsed the keyboard
        if (!deviceCharacteristics.is_touch) {
            if (this.templateLocation === domSelector) {
                if (!isSiteSearchOpen()) {
                    $.event.trigger({
                        type: OPEN_SITE_SEARCH
                    });
                }
            }
        }
    });

    $(document).on(this.scopedEvent('touchend click'), '.js-clear-search-input', (e) => {
        $(`${domSelector} ${searchInputSelector}`).val('');
        store.dispatch(enhancedSaytSearchResults({}, [], 'header'));
        store.dispatch(editSiteSearch(false, 'header'));
    });

    $(document).on(this.scopedEvent('submit'), this.scopedSelector('.js-site-search__form'), (e) => {
        const $input = $(e.target).find(searchInputSelector);
        const newVal = sanitizeInput($input.val());

        $input.val(newVal);

        if (!newVal) {
            return false;
        }

        handleSearchSubmitAnalytics(store, newVal);

        return true;
    });

    // 'keydown' allows users to navgiate through sayt suggestion items using up and down arrows
    $(document).on(this.scopedEvent('keydown'), this.scopedSelector('.js-site-search-sayt'), (e) => {
        const UP = 38;
        const DOWN = 40;

        if (e.keyCode === UP) {
            e.preventDefault();
            $('.js-search-suggestion:focus').closest('.js-site-search-sayt__li')
                                            .prev()
                                            .find('.js-search-suggestion')
                                            .focus();
        }

        if (e.keyCode === DOWN) {
            e.preventDefault();
            $('.js-search-suggestion:focus').closest('.js-site-search-sayt__li')
                                            .next()
                                            .find('.js-search-suggestion')
                                            .focus();
        }
    });

    // 'keydown' on space/right arrow allows user to enter search term but not apply
    $(document).on(this.scopedEvent('keydown'), this.scopedSelector('.js-search-suggestion'), (e) => {
        const SPACE = 32;
        const RIGHT = 39;
        const ESCAPE = 27;

        if (e.keyCode === ESCAPE) {
            const scopedSelector = $(this.scopedSelector(searchInputSelector));

            scopedSelector.val("");
            store.dispatch(enhancedSaytSearchResults({}, [], scopedSelector.attr('data-search-source'), e));
        }

        if (e.keyCode === SPACE || e.keyCode === RIGHT) {
            e.preventDefault();
            const searchTerm = $(e.target).text()
                                          .trim();
            const searchSource = _this.getSearchValue();
            const searchFieldHeader = $(_this.scopedSelector(searchInputSelector));
            const inputHasValueHeader = searchTerm.length > 0;

            store.dispatch(enhancedSaytSearch(searchTerm, searchSource, e));

            if (inputHasValueHeader) {
                _this.setSearchValue(searchTerm);
                $(searchFieldHeader).blur();
            }
        }
    });

    // send SAYT GA event
    $(document).on(this.scopedEvent('click'),
        this.scopedSelector('.js-search-suggestion, .js-product-tile__image-link, .js-product-tile-title-link'), (e) => {
            let selectedElement = $(e.target).closest('[data-suggestion-type]');
            if ($(e.currentTarget).hasClass('js-product-tile-title-link')) {
                // the tile's "title" was clicked, direct to its associated image.
                selectedElement = $(e.currentTarget).parent()
                                                    .prev()
                                                    .find('.js-product-tile__image-link');
            }
            const suggestionType = $(selectedElement).attr('data-suggestion-type'); // "event_action" for GA event
            const index = $(selectedElement).attr('data-suggestion-index');
            const saytSelection = getSaytEventLabel(selectedElement, suggestionType);

            if (saytSelection && suggestionType && index) {
                handleSaytSearch.bind(this)(store, saytSelection, suggestionType, index);
            } else {
                console.error(`SAYT GA event failed: ${saytSelection}, ${suggestionType}, ${index}`);
            }
        });
}

export function init(store, overrides = {}) {
    const config = {
        templateLocation: domSelector,
        className: 'dom-site-search',
        watch: ['core.sayt.header'],
        name: 'enhancedSearchComponent',
        attachEvents: attachEvents,
        template: template,
        renderType: mDom,
        firstRender: firstRender,
        renderOptions: mDomMaintainInputVals,
        getSearchValue: getSearchValue,
        generateDictionary: generateComponentDictionary,
        setSearchValue: setSearchValue
    };

    return generate(config, store, overrides, getDefaultOptions(store));
}
